<template>
  <div>
    <AuthViewIntro :title="$t('profile.forgot-pass.enter-the-code')" />

    <p class="verify-otp__target">
      {{ $t('profile.auth.code-sent-to') }}
      <span class="verify-otp__email">{{ email }}</span>
    </p>

    <AuthOtpInput
      :value="value"
      :length="OTP_LENGTH"
      :disabled="verifying"
      @input="$emit('input', $event)"
      @complete="submit" />

    <div class="verify-otp__resend">
      <button
        type="button"
        class="verify-otp__link"
        :disabled="resendCountdown > 0 || verifying"
        @click="$emit('resend')">
        {{ resendLabel }}
      </button>
    </div>

    <AuthSubmitButton :disabled="!isComplete" :loading="verifying" @click="submit">
      {{ $t('profile.forgot-pass.continue') }}
    </AuthSubmitButton>

    <button type="button" class="verify-otp__secondary" @click="$emit('change-email')">
      {{ $t('profile.auth.use-different-email') }}
    </button>
  </div>
</template>

<script>
  import AuthViewIntro from '../../AuthViewIntro.vue';
  import AuthOtpInput from '../../AuthOtpInput.vue';
  import AuthSubmitButton from '../../AuthSubmitButton.vue';

  const OTP_LENGTH = 6;

  export default {
    name: 'VerifyOtpStep',
    components: {
      AuthViewIntro,
      AuthOtpInput,
      AuthSubmitButton
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      email: {
        type: String,
        default: ''
      },
      resendCountdown: {
        type: Number,
        default: 0
      },
      verifying: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        OTP_LENGTH: OTP_LENGTH
      }
    },
    computed: {
      isComplete() {
        return this.value.length === OTP_LENGTH;
      },
      resendLabel() {
        if (this.resendCountdown > 0) {
          return this.$t('profile.auth.resend-in', { seconds: this.resendCountdown });
        }
        return this.$t('profile.auth.resend-code');
      }
    },
    methods: {
      submit() {
        if (!this.isComplete || this.verifying) return;
        this.$emit('submit');
      }
    }
  }
</script>

<style scoped>
.verify-otp__target {
  margin: 0 0 20px;
  font-size: 0.875rem;
  color: #6B7886;
  text-align: center;
}
.verify-otp__email {
  display: block;
  margin-top: 2px;
  font-weight: 600;
  color: #1C2B36;
  word-break: break-all;
}
.verify-otp__resend {
  margin: 20px 0;
  text-align: center;
}
.verify-otp__link {
  padding: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--merchant-primary-color, #1AA179);
  background: transparent;
  border: none;
  cursor: pointer;
}
.verify-otp__link:disabled {
  color: #A3AFBB;
  cursor: default;
}
.verify-otp__secondary {
  display: block;
  width: 100%;
  margin-top: 14px;
  padding: 0;
  font-size: 0.8125rem;
  color: #6B7886;
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/views/forgot-password/VerifyOtpStep.vue